export interface Settings {
    approvalTool: 'manual'|'integrated'
}

export interface IGraphUser {
    businessPhones: string[];
    displayName: string;
    givenName: string;
    jobTitle: string;
    mail: string;
    mobilePhone: string;
    officeLocation: string;
    preferredLanguage: string;
    surname: string;
    userPrincipalName: string;
    id: string;
    dynamicsId?: string;
}

export interface IToken {
    id: number,
    name: string,
    token: string
}

export interface IUnit {
    id: number;
    parent_unit?: IUnit;
    name: string;
    /**
     * GraphId of User object
     * @type string
     */
    owner: string;
}

export enum RequestState {
    AwaitsAcceptance,
    Running,
    Completed,
    Failed
}

export enum Acceptance {
    NoAction,
    Accepted,
    Declined
}

export type LogStatus = 'info' | 'warning' | 'error' | 'success';

export interface ILog {
    id: number,
    description: string,
    status: LogStatus,
    timestamp: number,
    group?: IGroup;
}

export type GroupType = 20 | 25 | 50 | 55 | 56;

export interface IGroup {
    requestId: string;
    requester: string;
    /**
     * GraphId of User object, "Deputy"
     */
    secondary_owner: string;
    secondary_accepted?:Acceptance;
    description:string;
    /**
     * GraphIf of User object, "Unit manager / Project owner /etc."
     */
    primary_owner: string;
    primary_accepted?:Acceptance;
    name: string;
    type: GroupType;
    request_state: RequestState;
    logs: ILog[],
    forced?: boolean,
    /**
     * Unit object only for groups of type
     * <pre>
     *     20 -> internal group
     *     25 -> internal project
     * </pre>
     */
    unit?: IUnit;
    /**
     * Dynamics Id of customer object<br>
     * Only for groups of type:
     * <pre>
     *     50 -> customer group
     * </pre>
     */
    customer?: string;
    /**
     * Dynamics Id of customer related project<br>
     * Only for groups of type:
     * <pre>
     *     55 -> customer group
     * </pre>
     */
    project?: string;

    aadGroupId?: string;
    aadAccessPackageId?: string;
    aadOwnerPolicyId?: string;
    aadMemberPolicyId?: string;
    aadGuestPolicyId?: string;

    deletedAt?: Date;
    updatedAt?: Date;
}

export type ActionType = 'pre_create' | 'create' | 'delete' | 'owner_change' | 'aborted';

export interface IFlowExecution {
    id: number;
    flow: IFlow;
    group_type: GroupType;
    action: ActionType;
    order: number;
    isDisabled?: boolean;
    extraPayload?: string;
}

export interface IFlow {
    id: number;
    url: string;
    name: string;
    flowExecution: IFlowExecution[];
}

export interface DynamicsCompany {
    accountid: string,
    d365_ownerid: string,
    name: string,
    parrentaccountid: string | number,
    pvt_customernumber: string,
    statuscode: number,
    versionnumber: number,
    ownerid: string
}

export interface DynamicsProject {
    "pvt_projecttype@OData.Community.Display.V1.FormattedValue": string;
    pvt_projecttype:                                             number;
    pvt_projectnumber:                                           string;
    _pvt_teamleadid_value:                                       string;
    _msdyn_projectmanager_value:                                 string;
    msdyn_subject:                                               string;
    statecode:                                                   number;
    msdyn_projectid:                                             string;
    _msdyn_customer_value:                                       string;
    pvt_internalproject:                                         boolean;
}
export interface DynamicsOrder {
    "orderNumber": string;
    "name": string;
    "customerId": string;
}

export type CreateGroupRequest =
    Omit<IGroup, 'requestId' | 'request_state' | 'project' | 'logs' | 'unit'>
    & { childUnit?: number, unit?: number, project?: string };
export type SpaceAcceptanceRequest = { state: 'accept' | 'decline' | 'force', reason: string };

export interface RequestFetchUnits {
    secondary: IUnit[],
    main: IUnit[],
}

export interface IAssignedMembers {
    assigned: AssignedUsersResponse[],
    current: IGraphUser[]
}

export interface AssignedUsersResponse {
    assignmentStatus: string,
    id: string,
    schedule: {
        startDateTime: string,
        recurrence: string | null,
        expiration: {
            endDateTime: string | null,
            duration: number | null,
            type: string
        }
    }
    target: {
        id: string,
        objectId: string,
        displayName: string
    }
}

export enum ActionPlace {
    Details
}

export interface IAction {
    id: number;
    flow: IFlow;
    name: string;
    place: ActionPlace;
    extraPayload?:string;
}

export interface IChangeRequest {
    id: number;
    reason: string,
    request_state: Acceptance,
    type: 'PRIMARY'|'SECONDARY',
    old_owner: string;
    new_owner: string;
    requester: string;
    space: IGroup;
    createdAt: Date;
    updatedAt?: Date;
    deletedAt?: Date;
}

